module.exports = __webpack_public_path__ + "static/media/ningde.bb9b794.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/fujian/ningde.mp4
// module id = k+JT
// module chunks = 6